import {BookingMutationActionBase} from "../booking-mutation-action-base";

/**
 * This class is just a way to mark all seat mutations
 * so we can restrict the arguments passed to BookingMutationsManagerModel.startSeatMutation
 */
export abstract class SeatMutationBase extends BookingMutationActionBase {

}
